import React, { FC, ReactNode } from 'react';
import { Button, ButtonProps } from 'antd';
import { useForm, useFormState } from 'react-final-form';

type IProps = ButtonProps & {
  children: ReactNode;
};

const FormAntButton: FC<IProps> = ({ children, onClick, ...props }) => {
  const form = useForm();
  const { submitting, hasValidationErrors } = useFormState();

  const handleClick: ButtonProps['onClick'] = event => {
    onClick?.(event);

    if (!event.defaultPrevented) {
      void form.submit();
    }
  };

  return (
    <Button
      type="primary"
      htmlType="button"
      loading={submitting}
      disabled={submitting || hasValidationErrors}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default FormAntButton;
